import { getUid } from '@tencent/docs-login';
import ua from '@tencent/docs-user-agent';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { IGNORE_ERRORS } from './constant';
import { getApp, isMiniProgram } from '../offline-data-report/common-ext-data';
import ENV from '../../runtime-environment/enviroment';
import { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

/** TAM 前端组件上报项目 id */
const tamProjectId = getCacConfigByKey('custom.common.aegisID', 'ZvszvAcZRLGIWozYaO');
const uin = getUid() || window?.basicClientVars?.userInfo?.tinyId || '';
const url = `https://aegis.qq.com/collect?id=${tamProjectId}&uin=${uin}`;
const TAM_IGNORE_ERRORS = IGNORE_ERRORS.concat([
    'ResizeObserver loop completed with undelivered notifications.',    // 同ResizeObserver loop limit exceeded(Safari, Firefox，IE https://km.woa.com/group/51926/articles/show/526802)
    'Script error. @ (:0:0)', // Script error. 也被称为跨域错误，当网站请求并且执行一个非本域名下的脚步的时候，如果跨域脚本发生错误，就有可能抛出这个错误。无影响，暂时忽略。https://km.woa.com/group/11800/articles/show/386426?kmref=search&from_page=1&no=1
    'Script error.',
    // '[docs-login] login-track failed: not-logged-in', // 无用，docs-login最新版本已忽略该报错
]);
const COMMIT_HASH_LENGTH = 22;
const reportedErrors = {};  // 缓存上报的数据，一个错误信息只上报一次

export enum LogType {
    ERROR = '4',    // js error
    PROMISE_ERROR = '8',    // promise error
}

export enum Environment {
    production = 'production',
    test = 'test',
}

/**
 * 将错误信息直接上报到tam
 * @param message 错误信息
 * @param uin 用户uin
 */
export function reportErrorToTam(event, logType: LogType): void {
    let message = '';
    let msgStack: string[] = [];
    if (event?.message) {
        message = event.message;
        msgStack = [event.error?.stack ?? message];
    } else if (event?.reason) {
        message = event.reason.message;
        msgStack = [event.reason.stack ?? message];
    }

    // 仅mater、hotfix、release上报
    if (!/^(master|hotfix|release)/.test(global.__globalReleaseVersion)) {
        return;
    }

    // 部分error已知，直接忽略
    if (isIgnoreError(message)) {
        return;
    }

    if (reportedErrors[message]) {
        return;
    }
    reportedErrors[message] = true;

    const extraConfig = getAegisExtraConfig();
    const bodyData = {
        level: [logType],
        msg: msgStack,
        count: 1,
        env: ENV.IS_TEST ? Environment.test : Environment.production,
        from: window.location.href,
        ...extraConfig,
    };
    window?.fetch?.(url, {
        method: 'POST',
        body: JSON.stringify(bodyData),
    });
}

// eslint-disable-next-line complexity
const isIgnoreError = (msg): boolean => {
    // 无内容异常 - 忽略
    if (!msg) {
        return true;
    }

    // 已知的可忽略异常 - 忽略
    if (TAM_IGNORE_ERRORS.some(errStr => msg.match(errStr))) {
        return true;
    }

    // ios16的qq浏览器存在此报错，非正常入口，可忽略（后期浏览器兼容后可移除）
    if (browser.isIOS && ua.isQQBrowser && msg.match(/NetworkError: Load failed/)) {
        return true;
    }
    return false;
};

export const getAegisExtraConfig = () => {
    // 分支名
    const length = global.__globalReleaseVersion?.length;
    const version = global.__globalReleaseVersion?.slice(0, length - COMMIT_HASH_LENGTH - 1);
    const commitId = global.__globalReleaseVersion?.slice(-COMMIT_HASH_LENGTH);
    const extraInfo = JSON.stringify({
        app: getApp(),
        isMiniProgram: isMiniProgram(),
    });
    const baseConfig = {
        version,
        ext1: commitId,
        ext2: extraInfo,
    };
    return baseConfig;
};
